const invertedMessages = {
  'Identity Verification': 'external.idpSetUp.identityVerification',
  'License key': 'external.idpSetUp.license',
  'Enter License key': 'external.idpSetUp.license.placeholder',
  'Verification Config ID': 'external.idpSetUp.dvcID',
  'Enter Verification Config ID': 'external.idpSetUp.dvcID.placeholder',
  'Tenant DNS': 'external.idpSetUp.TenantDNS',
  'Enter Tenant DNS': 'external.idpSetUp.TenantDNS.placeholder',
  DNS: 'external.idpSetUp.DNS',
  'Enter DNS': 'external.idpSetUp.DNS.placeholder',
  'Invalid input': 'external.idpSetUp.invalidInput',
  'Please enter valid input.': 'external.idpSetUp.errorMsg',
  'Community Name': 'external.idpSetUp.communityName',
  'Enter Community Name': 'external.idpSetUp.communityName.placeholder',
  Back: 'external.idpSetUp.back',
  Save: 'external.idpSetUp.save',
  Environment: 'external.idpSetUp.environment',
  'Select Environment': 'external.idpSetUp.environment.placeholder',
  'Which document you would like to verify?': 'external.idpSetUp.document',
  'Select Document': 'external.idpSetUp.document.placeholder',
  Passport: 'external.idpSetup.document.passport',
  'Driver’s License': 'external.idpSetup.document.driversLicense',
  'Any Document': 'external.idpSetup.document.anyDocument',
  Saving: 'external.idpSetUp.saving',
};

export default invertedMessages;
